import { render, staticRenderFns } from "./ProceduresInitial.vue?vue&type=template&id=0dd04b8a&scoped=true"
import script from "./ProceduresInitial.vue?vue&type=script&lang=js"
export * from "./ProceduresInitial.vue?vue&type=script&lang=js"
import style0 from "./ProceduresInitial.vue?vue&type=style&index=0&id=0dd04b8a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd04b8a",
  null
  
)

export default component.exports